/* -----------------Globals--------------- */
import {
	Stack,
	useFocusEffect,
	useLocalSearchParams,
	useRouter,
} from "expo-router";

import { pageViewTypes } from "@constants/tracking";
/* -----------------Child components--------------- */
import RedeemCodeCopilotWrapper from "@features/redeem/components/RedeemCodeCopilotWrapper";
import { handleNavigateBack } from "@helpers/common";
import { replayManager } from "@helpers/lib/sentry";
import { isWeb } from "@helpers/platform";
import useAnalytics from "@hooks/useAnalytics";
import { CustomAppBar } from "@memorang/ui/components/CustomAppbar";
import { useCallback, useMemo } from "react";

const RedeemRoute = () => {
	const { step } = useLocalSearchParams<{
		step: string;
	}>();

	useFocusEffect(
		useCallback(() => {
			if (isWeb) {
				replayManager().startReplay();
			} else {
				router.push("/home");
			}
		}, []),
	);

	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.redeem,
		};
	}, []);

	useAnalytics(memoizedAnalyticsParams);
	const router = useRouter();
	const isSuccessStep = step === "success";
	const title = isSuccessStep ? "Access code redeemed" : "Have an access code?";

	return (
		<>
			<Stack.Screen
				options={{
					headerShown: true,
					header: () => {
						return (
							<CustomAppBar
								title={title}
								leftIconType="back"
								onPressBack={() => {
									handleNavigateBack("/(protected)/(tabs)/home");
								}}
								hideCommandBar
							/>
						);
					},
				}}
			/>
			<RedeemCodeCopilotWrapper />
		</>
	);
};

export default RedeemRoute;
